import { Button, Typography, Breadcrumb } from "antd";
import { editIcon, archiveIcon, statsIcon } from "svgs";
import { ComponentType } from ".";
import ImageCatalog from "./image-catalog";
import { backIcon, breadcrumbIcon, settingsIcon2 } from "svgs";
import { useSelector } from "react-redux";
import { AppState } from "store";
import "styles/components/tab-content/vehicles-content/gallery.scss";

interface ComponentProps {
  onEditVehicle: VoidFunction;
  onArchiveVehicle: VoidFunction;
  onChangeComponent: (component: ComponentType) => void;
  onClickBack: VoidFunction;
}

const { Title, Text } = Typography;

export default function Gallery(props: ComponentProps) {
  const { onEditVehicle, onArchiveVehicle, onChangeComponent, onClickBack } = props;

  const { selectedVehicle } = useSelector<AppState, AppState["vehicles"]>(
    (state) => state.vehicles
  );

  return (
    <section className="__gallery-container">
      <div className="action-container">
        <Breadcrumb className="" separator={breadcrumbIcon}>
          <Breadcrumb.Item>
            <Button type="link" className="vehicles-link" onClick={onClickBack}>
              <span className="breadcrumb-text">Vehicle</span>
            </Button>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span className="breadcrumb-text">Vehicle Details</span>
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* <div className="action-buttons">
          <Button className="action-edit" icon={editIcon} onClick={onEditVehicle}>
            <span className="button-text">Edit</span>
          </Button>
          <Button
            className="action-archive"
            danger
            icon={archiveIcon}
            onClick={onArchiveVehicle}
          >
            <span className="button-text">Archive</span>
          </Button>
        </div> */}
      </div>
      <div className="vehicle-meta">
        {/* <span className="back-icon" onClick={onClickBack}>{backIcon}</span> */}
        <Title type="secondary" className="vehicle-no" level={5}>
          {selectedVehicle?.licensePlate}
          {/*<span
            className="view-stats"
            role="button"
            onClick={() => onChangeComponent("stats")}
          >
            {statsIcon} <span className="stats-text">View Stats</span>
          </span>*/}
        </Title>
        <Text className="sub-title">
          {/*<span>Vehicle No.</span>*/}
          {/*<span className="last-uploaded">Last Uploaded on Jan 01, 2020</span>*/}
        </Text>
      </div>
      
      <div className="image-catalog-wrapper">
        <ImageCatalog />
      </div>
    </section>
  );
}